import LandingCallPage from '@/components/Landing/CallPage';
import LandingFooter from '@/components/Landing/Footer';
import LandingHeader from '@/components/Landing/Header';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Head from 'next/head';
import style from './_landing/style.module.scss';
import { useTranslationByMetaTag } from '@/helper';

const Call = () => {
  return (
    <div className={style.callWrapper}>
      <Head>
        <title>{useTranslationByMetaTag('title')}</title>
        <meta name="description" content={useTranslationByMetaTag('description')} />
        <meta property="og:title" content={useTranslationByMetaTag('og_title')} />
        <meta property="og:description" content={useTranslationByMetaTag('og_description')} />

        <link rel="preconnect" href="https://assets.calendly.com" crossOrigin="anonymous" />
        <link rel="preconnect" href="https://calendly.com" crossOrigin="anonymous" />
        <link rel="dns-prefetch" href="https://assets.calendly.com" />
        <link rel="dns-prefetch" href="https://calendly.com" />
        <link
          rel="preload"
          href="https://assets.calendly.com/assets/external/widget.js"
          as="script"
        />

        <link rel="apple-touch-icon" sizes="180x180" href="/images/apple-touch-icon.png" />
        <link rel="icon" href="/images/favicon.svg" />
        <link rel="icon" type="image/png" sizes="32x32" href="/images/favicon-32x32.png" />
        <link rel="icon" type="image/png" sizes="16x16" href="/images/favicon-16x16.png" />
        <link rel="manifest" href="/site.webmanifest" />
        <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#080610" />
        <meta name="msapplication-TileColor" content="#080610" />
        <meta name="theme-color" content="#080610" />
      </Head>
      <LandingHeader />
      <LandingCallPage />
      <LandingFooter />
    </div>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common'])),
  },
  revalidate: 60 * 60,
});

export default Call;
